export default __webpack_public_path__ + "static/media/2018.d8024e53.png";